import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { Button } from "./ui/button";
import { PageHero } from "./PageHero";
import { Contact } from "./Contact";
import { mockData } from "../mock";

export const ContactPage = () => {
  return (
    <div data-testid="contact-page">
      <PageHero
        kicker="Get In Touch"
        title="Contact Our"
        highlight="Expert Team"
        subtitle="Ready to discuss your demolition project? Reach out to our veteran-owned team for a free consultation across the DMV area and nationwide."
      />

      {/* Emergency band */}
      <section className="relative py-12 border-b border-border overflow-hidden">
        <div className="absolute inset-0 hazard-stripe opacity-[0.05]" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center border border-primary/30 bg-primary/10 text-primary">
              <MessageCircle className="h-6 w-6" />
            </div>
            <div>
              <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-white">Emergency Services</h3>
              <p className="text-gray-400">Time-sensitive demolition? We offer rapid emergency response.</p>
            </div>
          </div>
          <Button
            data-testid="contact-page-emergency-btn"
            size="lg"
            onClick={() => (window.location.href = `tel:${mockData.contact.phone}`)}
            className="rounded-none font-bold uppercase tracking-widest px-8 py-6"
          >
            <Phone className="mr-2 h-5 w-5" /> Call {mockData.contact.phone}
          </Button>
        </div>
      </section>

      <Contact />
    </div>
  );
};
